import { Project } from "@/types";

interface DetailStoreType extends Project {
  tencentCharityTipsShow: boolean;
} 

// 主要用于存储选中的项目，类型如Project
export const DetailStore = {
  title: '',
  desc: '',
  tencentCharityTipsShow: false,
} as DetailStoreType;
